import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LayoutSwitcher from "./LayoutSwitcher";
import DashboardPageSwitcher from "./DashboardPageSwitcher";
import PainelTv from "../pages/PainelTv";
import TicketsPageSwitcher from "./TicketsPageSwitcher";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import FaqModeration from "../pages/FaqModeration";
import KnowledgeBase from "../pages/KnowledgeBase";
import OnCall from "../pages/OnCall";
import AiCosts from "../pages/AiCosts";
import PendingConfirmation from "../pages/PendingConfirmation";
import SefazMonitor from "../pages/SefazMonitor";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments"
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import QuickMessages from "../pages/QuickMessages";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { LayoutPreferenceProvider } from "../context/LayoutPreference/LayoutPreferenceContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
// import Integrations from '../pages/Integrations';
// import GoogleCalendarComponent from '../pages/Integrations/components/GoogleCalendarComponent';
import FlowBuilder from "../pages/FlowBuilder";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files";
import Boards from "../pages/Boards";
import ClientesCriticos from "../pages/ClientesCriticos";
import Commercial from "../pages/Commercial";
import TechnicalPassword from "../pages/TechnicalPassword";
import Tasks from "../pages/Tasks";
import TagsKanban from "../pages/TagsKanban";
import ForgotPassword from "../pages/ForgetPassWord";
import ResetPassword from "../pages/ResetPassword";


const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/painel-tv" component={PainelTv} isPrivate />
            <Route exact path="/senha-tecnica" component={TechnicalPassword} isPrivate />
            <WhatsAppsProvider>
              <LayoutPreferenceProvider>
              <LayoutSwitcher>
                <Route exact path="/financeiro" component={Financeiro} isPrivate />

                <Route exact path="/companies" component={Companies} isPrivate />
                <Route exact path="/" component={DashboardPageSwitcher} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={TicketsPageSwitcher} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/contacts/import" component={ContactImportPage} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/faq-moderation" component={FaqModeration} isPrivate />
                <Route exact path="/knowledge-base" component={KnowledgeBase} isPrivate />
                <Route exact path="/on-call" component={OnCall} isPrivate />
                <Route exact path="/ai-costs" component={AiCosts} isPrivate />
                <Route exact path="/pending-confirmations" component={PendingConfirmation} isPrivate />
                <Route exact path="/sefaz-monitor" component={SefazMonitor} isPrivate />
                <Route exact path="/messages-api" component={MessagesAPI} isPrivate />
                <Route exact path="/settings" component={SettingsCustom} isPrivate />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route exact path="/reports" component={Reports} isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />
                <Route exact path="/announcements" component={Annoucements} isPrivate />
                <Route
                  exact
                  path="/phrase-lists"
                  component={CampaignsPhrase}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilders"
                  component={FlowBuilder}
                  isPrivate
                />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route exact path="/moments" component={ChatMoments} isPrivate />
                <Route exact path="/boards/:boardId?" component={Boards} isPrivate />
                <Route exact path="/clientes-criticos" component={ClientesCriticos} isPrivate />
                <Route exact path="/commercial" component={Commercial} isPrivate />
                <Route exact path="/tasks" component={Tasks} isPrivate />
                <Route exact path="/Kanban" render={() => <Redirect to="/boards" />} isPrivate />
                <Route exact path="/TagsKanban" component={TagsKanban} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route exact path="/allConnections" component={AllConnections} isPrivate />
                {showCampaigns && (
                  <>
                    <Route exact path="/contact-lists" component={ContactLists} isPrivate />
                    <Route exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} isPrivate />
                    <Route exact path="/campaigns" component={Campaigns} isPrivate />
                    <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                    <Route exact path="/campaigns-config" component={CampaignsConfig} isPrivate />
                  </>
                )}
              </LayoutSwitcher>
              </LayoutPreferenceProvider>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer position="top-center" autoClose={3000} />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
